import time from './time'
import ui from './ui'

export default {
  time,
  ui
}
